import { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import { KTBSDropdownAlignments } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomCardMore from 'general/components/Others/CustomCardMore';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import EmptyView from 'general/components/Others/EmptyView';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import DoughnutChartJS from 'general/components/quybka/Charts/DoughnutChartJS';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';

DashboardHomeView.propTypes = {};

function DashboardHomeView(props) {
  // MARK: ---- PROPERTIES ----
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user.role === 'ADMIN';
  const [loadingDailyData, setLoadingDailyData] = useState(false);
  const [loadingRealtimeData, setLoadingRealtimeData] = useState(false);
  // thong tin xe ghep
  const [rideDashboardData, setRideDashboardData] = useState(null);
  const [loadingRideDashboard, setLoadingRideDashboard] = useState(false);
  const defaultRideFilter = useMemo(() => ({
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.baMuoiNgayGanNhat,
  }), []);
  const [rideFilter, setRideFilter] = useState(defaultRideFilter);
  const [rideFilterDraft, setRideFilterDraft] = useState(defaultRideFilter);
  // thong tin tru sac
  const [chargePointStatistic, setChargePointStatistic] = useState({
    total: 0,
    charging: 0,
    connected: 0,
  });
  // thong tin he thong
  const [systemStatistic, setSystemStatistic] = useState({
    totalEnergy: 0, // san luong dien trong ngay
    totalPower: 0, // cong suat tuc thi cua he thong
    totalTransactions: 0, // tong so phien sac trong ngay
    totalChargeDuration: 0, // tong thoi gian sac trong ngay
  });
  // bieu do
  const [chartData, setChartData] = useState({});
  const [energyCashFlow, setEnergyCashFlow] = useState({});
  const energyCashFlowRequestIdRef = useRef(0);
  const [chartFilter, setChartFilter] = useState({
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.baMuoiNgayGanNhat,
  });
  const defaultEnergyCashFlowFilter = useMemo(() => ({
    page: 0,
    limit: 10,
    q: '',
    stationId: '',
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.baMuoiNgayGanNhat,
  }), []);
  const [energyCashFlowFilter, setEnergyCashFlowFilter] = useState(defaultEnergyCashFlowFilter);
  const [energyCashFlowFilterDraft, setEnergyCashFlowFilterDraft] = useState(defaultEnergyCashFlowFilter);
  const [selectedCashFlowStationDraft, setSelectedCashFlowStationDraft] = useState(null);

  const applyEnergyCashFlowFilter = useCallback((patch) => {
    const normalizedPatch = {
      ...patch,
      page: 0,
      limit: 10,
    };
    setEnergyCashFlowFilter((prev) => ({
      ...prev,
      ...normalizedPatch,
    }));
    setEnergyCashFlowFilterDraft((prev) => ({
      ...prev,
      ...normalizedPatch,
    }));
  }, []);

  useEffect(() => {
    ChargeHelper.API.Dashboard.requestGetDailyData({
      from: chartFilter.from,
      to: chartFilter.to,
    }).then((res) => {
      setChartData(res ?? {});
    });
  }, [chartFilter]);

  useEffect(() => {
    const requestId = energyCashFlowRequestIdRef.current + 1;
    energyCashFlowRequestIdRef.current = requestId;
    const rawQuery = String(energyCashFlowFilter.q ?? '').trim();
    const requestQuery = /^c(?:t0*)?$/i.test(rawQuery) ? '' : rawQuery;
    ChargeHelper.API.Dashboard.requestGetEnergyCashFlow({
      ...energyCashFlowFilter,
      q: requestQuery,
    }).then((res) => {
      if (requestId !== energyCashFlowRequestIdRef.current) return;
      setEnergyCashFlow(res ?? {});
    });
  }, [energyCashFlowFilter]);
  useEffect(() => {
    requestGetRealtimeData();
    requestGetAgencyStatistic();
    requestGetRevenueSummary();
    const timer = setInterval(() => {
      requestGetRealtimeData();
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    setEnergyFilter({ ...chartFilter, energyType: energyType });
    setTransactionFilter({ ...chartFilter, transactionType: transactionType });
    setEnergyRevenueFilter({ ...chartFilter, energyRevenueType: energyRevenueType });
    setRevenueFilter({ ...chartFilter, revenueType: revenueType });
  }, [chartFilter])

  const processVehicleData = (data) => {
    if (!data) return;
    const transactionCount = {
      CAR: [],
      BIKE: []
    };
    const totalRevenue = {
      CAR: [],
      BIKE: []
    };
    const totalEnergy = {
      CAR: [],
      BIKE: []
    };

    data?.forEach(day => {
      const date = day.date;

      const carData = day.vehicleTypes.find(v => v.vehicleType === "CAR");
      const bikeData = day.vehicleTypes.find(v => v.vehicleType === "BIKE");

      transactionCount.CAR.push({
        date: date,
        transactions: carData.transactionCount || 0
      });
      transactionCount.BIKE.push({
        date: date,
        transactions: bikeData.transactionCount || 0
      });

      totalRevenue.CAR.push({
        date: date,
        amount: carData.totalRevenue || 0
      });
      totalRevenue.BIKE.push({
        date: date,
        amount: bikeData.totalRevenue || 0
      });

      totalEnergy.CAR.push({
        date: date,
        energy: carData.totalEnergy || 0
      });
      totalEnergy.BIKE.push({
        date: date,
        energy: bikeData.totalEnergy || 0
      });
    });

    return {
      transactionCount,
      totalRevenue,
      totalEnergy
    };
  }

  const chartDataByVehicle = useMemo(() => {
    return processVehicleData(chartData?.dailyByVehicleType);
  }, [chartData])

  const mergeDataByDate = (dataByCar = [], dataByBike = [], dataName) => {
    const allDates = Array.from(
      new Set([...dataByCar.map(item => item.date), ...dataByBike.map(item => item.date)])
    );

    return allDates.map(date => {
      const carAmount = dataByCar.find(item => item.date === date)?.[dataName] || 0;
      const bikeAmount = dataByBike.find(item => item.date === date)?.[dataName] || 0;

      return { date, [dataName]: carAmount + bikeAmount };
    }).sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const getDataByType = (type, vehicleType, chartData, chartDataByVehicle) => {
    const typeMap = {
      transaction: {
        '': mergeDataByDate(
          chartDataByVehicle?.transactionCount?.CAR,
          chartDataByVehicle?.transactionCount?.BIKE,
          'transactions'
        ),
        BIKE: chartDataByVehicle?.transactionCount?.BIKE,
        CAR: chartDataByVehicle?.transactionCount?.CAR
      },
      energy: {
        '': mergeDataByDate(
          chartDataByVehicle?.totalEnergy?.CAR,
          chartDataByVehicle?.totalEnergy?.BIKE,
          'energy'
        ),
        BIKE: chartDataByVehicle?.totalEnergy?.BIKE,
        CAR: chartDataByVehicle?.totalEnergy?.CAR
      },
      revenue: {
        '': mergeDataByDate(
          chartDataByVehicle?.totalRevenue?.CAR,
          chartDataByVehicle?.totalRevenue?.BIKE,
          'amount'
        ),
        BIKE: chartDataByVehicle?.totalRevenue?.BIKE,
        CAR: chartDataByVehicle?.totalRevenue?.CAR
      }
    };

    return typeMap[type]?.[vehicleType] || null;
  };

  const [energyType, setEnergyType] = useState('');
  const [energyFilter, setEnergyFilter] = useState({ ...chartFilter, energyType: energyType });
  // dien sac theo ngay
  const chartEnergyByDateEl = useMemo(() => {
    const energyByDate = getDataByType('energy', energyType, chartData, chartDataByVehicle);
    if (!energyByDate) return;
    let labels = energyByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = energyByDate?.map((item) => ((item.energy ?? 0) / 1000).toFixed(3));
    if (energyByDate?.length > 31) {
      const groupedData = _.groupBy(energyByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.energy, 0);
        return (total / 1000).toFixed(3);
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê điện sạc"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)?.toFixed(3)) +
          ' kWh'
        }
        valueColor="rgba(41, 132, 238, 1)"
        actionEl={
          <DropdownFilterTable
            id="energyType"
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại điện sạc"
                  filterKey="energyType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions,
                  ]}
                  selectedValue={energyFilter.energyType}
                  handleChange={(value) => {
                    setEnergyFilter({ ...energyFilter, energyType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={energyFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setEnergyFilter({
                      ...energyFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setEnergyFilter({ ...updateChartFilter, energyType: '' });
              setEnergyType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { energyType, ...dateFilter } = energyFilter;
              setChartFilter(dateFilter);
              setEnergyType(energyType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, energyType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Điện sạc"
            unit="kWh"
            labels={labels}
            data={data}
            color="rgba(41, 132, 238, 0.4)"
            hoverColor="rgba(41, 132, 238, 1)"
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter, energyFilter, energyType]);

  // doanh thu theo ngay
  const aggregateRevenueByDate = (investor, group, chargePoint) => {
    const allDates = chartData.revenueByDate?.map(item => item.date);

    const result = allDates?.map(date => {
      const investorItem = investor?.find(item => item.date === date);
      const investorAmount = investorItem ? investorItem.kpiValue : 0;
      const groupItem = group?.find(item => item.date === date);
      const groupAmount = groupItem ? groupItem.kpiValue : 0;
      const chargePointItem = chargePoint?.find(item => item.date === date);
      const chargePointAmount = chargePointItem ? chargePointItem.kpiValue : 0;

      const totalAmount = investorAmount + groupAmount + chargePointAmount;

      return { date, amount: totalAmount };
    });

    return result;
  }

  const getRevenueData = (type) => {
    switch (type) {
      case ChargeConstants.DashboardRevenueType.GROUP:
        return aggregateRevenueByDate(null, chartData.groupSaleByDate, null);
      case ChargeConstants.DashboardRevenueType.INVESTOR:
        return aggregateRevenueByDate(chartData.investorSaleByDate, null, null);
      case ChargeConstants.DashboardRevenueType.CHARGEPOINT:
        return aggregateRevenueByDate(null, null, chartData.chargePointSaleByDate);
      default:
        return aggregateRevenueByDate(chartData.investorSaleByDate, chartData.groupSaleByDate, chartData.chargePointSaleByDate);
    }
  }

  const [energyRevenueType, setEnergyRevenueType] = useState('');
  const [energyRevenueFilter, setEnergyRevenueFilter] = useState({ ...chartFilter, energyRevenueType: energyRevenueType });
  const chartEnergyRevenueByDateEl = useMemo(() => {
    const energyRevenueByDate = getDataByType('revenue', energyRevenueType, chartData, chartDataByVehicle);
    if (!energyRevenueByDate) return;
    let labels = energyRevenueByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = energyRevenueByDate?.map((item) => item.amount ?? 0);

    if (energyRevenueByDate?.length > 31) {
      const groupedData = _.groupBy(energyRevenueByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê doanh thu bán điện"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' VNĐ'
        }
        valueColor="#30BDA8"
        actionEl={
          <DropdownFilterTable
            id="energyRevenueType"
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại doanh thu"
                  filterKey="energyRevenueType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions,
                  ]}
                  selectedValue={energyRevenueFilter.energyRevenueType}
                  handleChange={(value) => {
                    setEnergyRevenueFilter({ ...energyRevenueFilter, energyRevenueType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={energyRevenueFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setEnergyRevenueFilter({
                      ...energyRevenueFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setEnergyRevenueFilter({ ...updateChartFilter, energyRevenueType: '' });
              setEnergyRevenueType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { energyRevenueType, ...dateFilter } = energyRevenueFilter;
              setChartFilter(dateFilter);
              setEnergyRevenueType(energyRevenueType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, energyRevenueType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Doanh thu"
            unit="VNĐ"
            labels={labels}
            data={data}
            color="#30BDA84D"
            hoverColor="#30BDA8"
            showLine={true}
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter, energyRevenueFilter, energyRevenueType]);


  const [revenueType, setRevenueType] = useState('');
  const [revenueFilter, setRevenueFilter] = useState({ ...chartFilter, revenueType: revenueType });
  const chartRevenueByDateEl = useMemo(() => {
    const revenueByDate = getRevenueData(revenueType) ?? [];
    let labels = revenueByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = revenueByDate?.map((item) => item.amount ?? 0);

    if (revenueByDate?.length > 31) {
      const groupedData = _.groupBy(revenueByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Doanh thu bán hàng"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' VNĐ'
        }
        valueColor="rgba(48, 189, 111, 1)"
        actionEl={
          <DropdownFilterTable
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại doanh thu"
                  filterKey="revenueType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.dashboardRevenueTypeOptions,
                  ]}
                  selectedValue={revenueFilter.revenueType}
                  handleChange={(value) => {
                    setRevenueFilter({ ...revenueFilter, revenueType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={revenueFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setRevenueFilter({
                      ...revenueFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setRevenueFilter({ ...updateChartFilter, revenueType: '' });
              setRevenueType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { revenueType, ...dateFilter } = revenueFilter;
              setChartFilter(dateFilter);
              setRevenueType(revenueType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, revenueType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Doanh thu"
            unit="VNĐ"
            labels={labels}
            data={data}
            color="rgba(48, 189, 111, 0.4)"
            hoverColor="rgba(48, 189, 111, 1)"
            showLine={true}
          />
        }
      />
    );
  }, [chartData, chartFilter, revenueFilter, revenueType]);

  // phien sac theo ngay
  const [transactionType, setTransactionType] = useState('');
  const [transactionFilter, setTransactionFilter] = useState({ ...chartFilter, transactionType: transactionType });
  const chartTransactionByDateEl = useMemo(() => {
    const transactionByDate = getDataByType('transaction', transactionType, chartData, chartDataByVehicle);
    if (!transactionByDate) return;
    let labels = transactionByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = transactionByDate?.map((item) => item.transactions ?? 0);

    if (transactionByDate?.length > 31) {
      const groupedData = _.groupBy(transactionByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.transactions, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê phiên sạc"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' phiên sạc'
        }
        valueColor="rgba(88, 86, 214, 1)"
        actionEl={
          <DropdownFilterTable
            id="transactionType"
            isLightButton={true}
            toggleElementBorderRadius={10}
            filterComponent={[
              <div className="col-12 p-0">
                <KTDropdownFilter
                  label="Loại phiên sạc"
                  filterKey="transactionType"
                  options={[
                    { name: 'Tất cả', value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions,
                  ]}
                  selectedValue={transactionFilter.transactionType}
                  handleChange={(value) => {
                    setTransactionFilter({ ...transactionFilter, transactionType: value });
                  }}
                />
              </div>,
              <div className="col-12 p-0">
                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                  Khoảng thời gian thống kê
                </label>
                <CustomDateRangePicker
                  alignRight={true}
                  toggleFontWeight="600"
                  toggleElementBorderRadius={5}
                  initialValue={transactionFilter.selectedValue}
                  onPressSave={(selectedValue, startDate, endDate) => {
                    setTransactionFilter({
                      ...transactionFilter,
                      from: startDate,
                      to: endDate,
                      selectedValue: selectedValue,
                    });
                  }}
                />
              </div>
            ]}
            resetDefaultTable={() => {
              const updateChartFilter = {
                ...chartFilter,
                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                selectedValue: dateFilter.baMuoiNgayGanNhat,
              };
              setTransactionFilter({ ...updateChartFilter, transactionType: '' });
              setTransactionType('');
              setChartFilter(updateChartFilter);
            }}
            saveFilter={() => {
              const { transactionType, ...dateFilter } = transactionFilter;
              setChartFilter(dateFilter);
              setTransactionType(transactionType);
            }}
            isDefaultFilter={Utils.checkDefaultFilter(
              ['selectedValue', 'from', 'to'],
              { ...chartFilter, transactionType },
              dateFilter.baMuoiNgayGanNhat,
            )}
          />
        }
        chartEl={
          <BarChart
            title="Phiên sạc"
            unit="phiên sạc"
            labels={labels}
            data={data}
            color="rgba(88, 86, 214, 0.4)"
            hoverColor="rgba(88, 86, 214, 1)"
          />
        }
      />
    );
  }, [chartDataByVehicle, chartData, chartFilter, transactionFilter, transactionType]);
  // khach hang nap tien theo ngay
  const chartTopupByDateEl = useMemo(() => {
    const topupCountByDate = chartData?.topupCountByDate ?? [];
    let labels = topupCountByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = topupCountByDate?.map((item) => item.topupCount ?? 0);

    if (topupCountByDate?.length > 31) {
      const groupedData = _.groupBy(topupCountByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.topupCount, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê khách hàng nạp tiền"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' giao dịch'
        }
        valueColor="#FF9500"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Giao dịch"
            unit="giao dịch"
            labels={labels}
            data={data}
            color="#FF95004D"
            hoverColor="#FF9500"
          />
        }
      />
    );
  }, [chartData, chartFilter]);
  // khach hang theo ngay
  const chartActiveUsersByDateEl = useMemo(() => {
    const activeUsersByDate = chartData?.activeUsersByDate ?? [];
    let labels = activeUsersByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = activeUsersByDate?.map((item) => item.activeUsers ?? 0);

    if (activeUsersByDate?.length > 31) {
      const groupedData = _.groupBy(activeUsersByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.activeUsers, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê khách hàng"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' khách hàng'
        }
        valueColor="rgba(253, 112, 139, 1)"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Khách hàng"
            unit="khách hàng"
            labels={labels}
            data={data}
            color="rgba(253, 112, 139, 0.4)"
            hoverColor="rgba(253, 112, 139, 1)"
          />
        }
      />
    );
  }, [chartData, chartFilter]);
  // khach hang moi theo ngay
  const chartNewUsersByDateEl = useMemo(() => {
    const newUsersByDate = chartData?.newUsersByDate ?? [];
    let labels = newUsersByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = newUsersByDate?.map((item) => item.newUsers ?? 0);

    if (newUsersByDate?.length > 31) {
      const groupedData = _.groupBy(newUsersByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels?.map((label) => {
        const total = groupedData[label]?.reduce((sum, item) => sum + item.newUsers, 0);
        return total;
      });
    }

    return (
      <DashboardChartCard
        title="Thống kê khách hàng"
        name="Tổng"
        value={
          Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
          ' khách hàng'
        }
        valueColor="rgba(253, 112, 139, 1)"
        actionEl={
          <CustomDateRangePicker
            alignRight={true}
            toggleFontWeight="600"
            toggleElementBorderRadius={10}
            initialValue={chartFilter.selectedValue}
            onPressSave={(selectedValue, startDate, endDate) => {
              setChartFilter({
                from: startDate,
                to: endDate,
                selectedValue: selectedValue,
              });
            }}
          />
        }
        chartEl={
          <BarChart
            title="Khách hàng mới"
            unit="khách hàng"
            labels={labels}
            data={data}
            color="rgba(253, 112, 139, 0.4)"
            hoverColor="rgba(253, 112, 139, 1)"
          />
        }
      />
    );
  }, [chartData, chartFilter]);
  // thong bao he thong
  const [filterSystemLog, setFilterSystemLog] = useState({
    page: 0,
    limit: 10,
    selectedValue: dateFilter.baMuoiNgayGanNhat,
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    stationId: '',
  });
  const [filterSystemLogDropdown, setFilterSystemLogDropdown] = useState({
    page: 0,
    limit: 10,
    selectedValue: dateFilter.baMuoiNgayGanNhat,
    from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    stationId: '',
  });
  const [selectedChargeStationSystemLog, setSelectedChargeStationSystemLog] = useState(null);
  const [systemLogList, setSystemLogList] = useState([]);
  const [totalSystemLog, setTotalSystemLog] = useState(0);
  // danh sach tru sac
  const [chargePointSummary, setChargePointSummary] = useState({});
  // thong ke tai khoan
  const [agencyStatistic, setAgencyStatistic] = useState({});
  // thong ke doanh thu
  const [revenueSummary, setRevenueSummary] = useState({});
  // filter
  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  useEffect(() => {
    let params = {};
    if (Utils.isValid(selectedChargeStation?.id)) {
      params.stationId = selectedChargeStation?.id;
    }
    ChargeHelper.API.Dashboard.requestGetPointSummary(params).then((res) => {
      setChargePointSummary(res ?? {});
    });
  }, [selectedChargeStation]);

  const filterChargeStationEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="station_filter"
        name="station_filter"
        toggleElement={UIHelper.buildWhiteButton(
          <div className="d-flex align-items-center gap-2">
            <span>
              {_.truncate(selectedChargeStation?.name ?? 'Tất cả trạm', {
                length: 20,
                separator: '...',
              })}
            </span>{' '}
            <i className="fa-solid fa-caret-down" />
          </div>,
          () => { console.log(''); },
          <div className="position-relative">
            <i className="fa-regular fa-filter" style={{ color: AppColors.gray[700] }} />
            {Utils.isValid(selectedChargeStation?.id) && (
              <i
                className="position-absolute fa-solid fa-circle"
                style={{
                  color: 'orange',
                  top: '-2px',
                  right: '-4px',
                  fontSize: '7px',
                }}
              />
            )}
          </div>,
          false,
          false,
          10
        )}
        selectedValue={selectedChargeStation}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        subTitleType="address"
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            let values = data.chargeStations?.map((station) => ({
              id: station?.stationId,
              name: station?.name,
              item: station,
              address: ChargeHelper.Utils.getChargeStationFullAddress(station),
            }));
            if (!Utils.isValid(item?.page) || _.toNumber(item?.page) === 0) {
              values = [
                {
                  id: null,
                  name: 'Tất cả trạm',
                  item: null,
                  address: '',
                },
              ].concat(values);
            }
            return {
              values: values,
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-300px"
        alignment={KTBSDropdownAlignments.end}
        onChange={(value) => {
          setSelectedChargeStation(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
      />
    );
  }, [selectedChargeStation]);

  const filterCashFlowStationEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="cash_flow_station_filter"
        name="cash_flow_station_filter"
        toggleElement={
          <button
            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button"
          >
            {_.truncate(selectedCashFlowStationDraft?.name ?? 'Tất cả trạm', {
              length: 24,
              separator: '...',
            })}
          </button>
        }
        selectedValue={selectedCashFlowStationDraft}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        subTitleType="address"
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            let values = data.chargeStations?.map((station) => ({
              id: station?.stationId,
              name: station?.name,
              item: station,
              address: ChargeHelper.Utils.getChargeStationFullAddress(station),
            }));
            if (!Utils.isValid(item?.page) || _.toNumber(item?.page) === 0) {
              values = [
                {
                  id: '',
                  name: 'Tất cả trạm',
                  item: null,
                  address: '',
                },
              ].concat(values);
            }
            return {
              values,
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        alignment={KTBSDropdownAlignments.end}
        onChange={(value) => {
          applyEnergyCashFlowFilter({
            stationId: value?.id || '',
          });
          setSelectedCashFlowStationDraft(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
      />
    );
  }, [applyEnergyCashFlowFilter, selectedCashFlowStationDraft]);

  const filterChargeStationSystemLogEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="stationId_filter"
        name="stationId_filter"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedChargeStationSystemLog?.name ?? 'Chọn trạm sạc'}
          </button>
        }
        selectedValue={selectedChargeStationSystemLog}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        subTitleType="address"
        getSubItems={async (item) => {
          return ChargeHelper.API.requestGetChargeStationList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.chargeStations?.map((station) => ({
                id: station?.stationId,
                name: station?.name,
                item: station,
                address: ChargeHelper.Utils.getChargeStationFullAddress(station),
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargeStationSystemLog(value);
          setFilterSystemLogDropdown({
            ...filterSystemLogDropdown,
            stationId: value?.id,
          });
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        direction='dropup'
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedChargeStationSystemLog(null);
              setFilterSystemLogDropdown({
                ...filterSystemLogDropdown,
                stationId: '',
              });
            })}
          </div>
        }
      />
    );
  }, [selectedChargeStationSystemLog]);

  // MARK: ---- METHODS ----
  const requestGetRevenueSummary = useCallback(() => {
    ChargeHelper.API.Dashboard.requestGetRevenueSummary({ month: moment().format('YYYY-MM') }).then(
      (res) => {
        setRevenueSummary(res ?? {});
      }
    );
  }, []);
  const requestGetAgencyStatistic = useCallback(() => {
    ChargeHelper.API.Dashboard.requestGetAgencyStatistics({}).then((res) => {
      setAgencyStatistic(res ?? {});
    });
  }, []);

  const requestGetRideStatistics = useCallback((filter = rideFilter) => {
    setLoadingRideDashboard(true);
    ChargeHelper.API.Dashboard.requestGetRideStatistics({
      from: filter.from,
      to: filter.to,
    })
      .then((res) => {
        setRideDashboardData(res ?? null);
      })
      .finally(() => {
        setLoadingRideDashboard(false);
      });
  }, [rideFilter]);

  useEffect(() => {
    requestGetRideStatistics(rideFilter);
  }, [rideFilter, requestGetRideStatistics]);

  useEffect(() => {
    const params = _.pickBy(
      filterSystemLog,
      (value) => value !== null && value !== undefined && value !== ''
    );

    ChargeHelper.API.SystemLog.requestGetSystemLogList(params)
      .then((response) => {
        setSystemLogList((prevList) => {
          if (filterSystemLog?.page !== 0) {
            const existingIds = new Set(prevList.map(item => item.messageId));
            const newUnique = (response?.messages ?? []).filter(
              item => !existingIds.has(item.messageId)
            );

            return [...prevList, ...newUnique];
          } else {
            return response?.messages ?? [];
          }
        });

        setTotalSystemLog(response?.total ?? 0);
      })
      .catch((error) => {
        console.error("Lỗi khi lấy system log:", error);
      });
  }, [filterSystemLog]);

  const requestGetRealtimeData = useCallback(() => {
    ChargeHelper.API.Dashboard.requestGetRealtimeData().then((res) => {
      setChargePointStatistic({
        total: res?.totalChargePoint ?? 0,
        charging: res?.chargingChargePoint ?? 0,
        connected: res?.connectedChargePoint ?? 0,
      });
      setSystemStatistic({
        totalEnergy: res?.totalEnergy ?? 0,
        totalPower: res?.totalPower ?? 0,
        totalTransactions: res?.totalTransactions ?? 0,
        totalChargeDuration: res?.totalChargeDuration ?? 0,
      });
    });
  }, []);

  const energyCashFlowEl = useMemo(() => {
    const summary = energyCashFlow?.summary ?? {};
    const rows = energyCashFlow?.rows ?? [];
    const total = energyCashFlow?.total ?? summary.sessionCount ?? rows.length;
    const page = energyCashFlow?.page ?? energyCashFlowFilter.page ?? 0;
    const limit = 10;
    const totalPages = Math.max(Math.ceil(total / limit), 1);
    const currentPage = Math.min(page + 1, totalPages);
    const activePage = currentPage - 1;
    const visibleRows = rows.length > limit
      ? rows.slice(activePage * limit, activePage * limit + limit)
      : rows;
    const displayTo = total > 0 ? Math.min(activePage * limit + visibleRows.length, total) : 0;
    const changeCashFlowPage = (nextPage) => {
      const safePage = Math.max(0, Math.min(nextPage, totalPages - 1));
      if (safePage === page) return;
      setEnergyCashFlowFilter((prev) => ({
        ...prev,
        page: safePage,
        limit,
      }));
      setEnergyCashFlowFilterDraft((prev) => ({
        ...prev,
        page: safePage,
        limit,
      }));
    };
    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1)
      .filter((pageNumber) => (
        pageNumber === 1
        || pageNumber === totalPages
        || Math.abs(pageNumber - currentPage) <= 1
      ));
    const resetCashFlowFilter = () => {
      setSelectedCashFlowStationDraft(null);
      setEnergyCashFlowFilterDraft(defaultEnergyCashFlowFilter);
      setEnergyCashFlowFilter(defaultEnergyCashFlowFilter);
    };
    const metrics = [
      { label: 'Khách đã trả', value: summary.customerPaid, color: AppColors.primary, icon: 'fa-solid fa-wallet' },
      { label: 'CĐT nhận', value: summary.investor, color: '#7C3AED', icon: 'fa-solid fa-building-user' },
      { label: 'MB nhận', value: summary.landlord, color: '#0EA5E9', icon: 'fa-solid fa-house-building' },
      { label: 'GT CĐT', value: summary.investorReferral, color: '#F59E0B', icon: 'fa-solid fa-handshake' },
      { label: 'GT MB', value: summary.premiseReferral, color: '#F97316', icon: 'fa-solid fa-link' },
      { label: 'Tiền điện', value: summary.electricityCost, color: '#64748B', icon: 'fa-solid fa-bolt' },
      { label: 'EVG vận hành', value: summary.evgOperation, color: '#16A34A', icon: 'fa-solid fa-sack-dollar' },
    ];

    const metricEl = (item) => (
      <div className="col-xl-3 col-lg-4 col-md-6 mb-3" key={item.label}>
        <div
          className="h-100 p-4 rounded"
          style={{
            border: `1px solid ${AppColors.gray[200]}`,
            background: '#fff',
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-flex align-items-center justify-content-center rounded"
              style={{
                width: 38,
                height: 38,
                color: item.color,
                background: `${item.color}14`,
              }}
            >
              <i className={item.icon} />
            </div>
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[600])}>
                {item.label}
                {item.tooltip && (
                  <KTTooltip text={item.tooltip}>
                    <i className="fa-regular fa-circle-info ml-2" style={{ color: AppColors.gray[500] }} />
                  </KTTooltip>
                )}
              </span>
              <span style={UIHelper.buildFontStyle('700', '18px', item.color)}>
                {Utils.formatNumber(item.value ?? 0)} VNĐ
              </span>
            </div>
          </div>
        </div>
      </div>
    );

    const pageButtonEl = (label, targetPage, disabled = false, active = false, key = `${targetPage}-${active}`) => (
      <button
        type="button"
        key={key}
        className="btn d-inline-flex align-items-center justify-content-center"
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          padding: 0,
          border: `1px solid ${active ? AppColors.primary : AppColors.gray[200]}`,
          background: active ? AppColors.primary : (disabled ? AppColors.gray[100] : '#fff'),
          color: active ? '#fff' : (disabled ? AppColors.gray[400] : AppColors.gray[700]),
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontWeight: 700,
        }}
        disabled={disabled}
        onClick={() => changeCashFlowPage(targetPage)}
      >
        {label}
      </button>
    );

    const paginationEl = totalPages > 1 || total > 0 ? (
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3">
        <div style={{ minWidth: 180 }} />
        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
          {pageButtonEl(<i className="fa-solid fa-angles-left" />, 0, currentPage <= 1, false, 'first')}
          {pageButtonEl(<i className="fa-solid fa-angle-left" />, activePage - 1, currentPage <= 1, false, 'prev')}
          {pageNumbers.reduce((elements, pageNumber, index) => {
            const prevPage = pageNumbers[index - 1];
            if (prevPage && pageNumber - prevPage > 1) {
              elements.push(
                <span
                  key={`ellipsis-${pageNumber}`}
                  className="d-inline-flex align-items-center justify-content-center"
                  style={{ width: 24, color: AppColors.gray[500], fontWeight: 700 }}
                >
                  ...
                </span>
              );
            }
            elements.push(pageButtonEl(
              pageNumber,
              pageNumber - 1,
              false,
              pageNumber === currentPage,
              `page-${pageNumber}`
            ));
            return elements;
          }, [])}
          {pageButtonEl(<i className="fa-solid fa-angle-right" />, activePage + 1, currentPage >= totalPages, false, 'next')}
          {pageButtonEl(<i className="fa-solid fa-angles-right" />, totalPages - 1, currentPage >= totalPages, false, 'last')}
        </div>
        <div
          className="text-lg-end"
          style={{
            minWidth: 180,
            ...UIHelper.buildFontStyle('600', '13px', AppColors.gray[600]),
          }}
        >
          Hiển thị <span style={{ color: AppColors.gray[800] }}>{displayTo}</span>/
          <span style={{ color: AppColors.primary }}>{Utils.formatNumber(total)} phiên sạc</span>
        </div>
      </div>
    ) : null;

    return UIHelper.buildCard(
      <div>
        <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 px-4 pt-4 pb-2">
          <div>
            <div style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
              Thống kê dòng tiền phiên sạc
            </div>
            <div style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[600])}>
              Tổng {Utils.formatNumber(summary.sessionCount ?? 0)} phiên - {Utils.formatNumber(summary.energyKWh ?? 0)} kWh
            </div>
          </div>
          <div style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[600])}>
            {Utils.formatDateTimeToString(energyCashFlow?.from, 'DD/MM/YYYY')} - {Utils.formatDateTimeToString(energyCashFlow?.to, 'DD/MM/YYYY')}
          </div>
        </div>

        <div className="mx-4 mt-3 mb-2 p-3 rounded" style={{ border: `1px solid ${AppColors.gray[200]}`, background: AppColors.gray[100] }}>
          <div className="row m-0 align-items-end">
            <div className="col-xl-3 col-lg-4 col-md-6 px-2 mb-3">
              <label className="mb-1" style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[600])}>
                Khoảng thời gian
              </label>
              <CustomDateRangePicker
                alignRight={false}
                toggleFontWeight="600"
                toggleElementBorderRadius={8}
                initialValue={energyCashFlowFilterDraft.selectedValue}
                onPressSave={(selectedValue, startDate, endDate) => {
                  applyEnergyCashFlowFilter({
                    from: startDate,
                    to: endDate,
                    selectedValue,
                  });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 px-2 mb-3">
              <label className="mb-1" style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[600])}>
                Trạm sạc
              </label>
              {filterCashFlowStationEl}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 px-2 mb-3">
              <label className="mb-1" style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[600])}>
                Tìm kiếm
              </label>
              <div className="input-group">
                <span className="input-group-text bg-white border-secondary">
                  <i className="fa-regular fa-magnifying-glass" style={{ color: AppColors.gray[500] }} />
                </span>
                <input
                  className="form-control border-secondary"
                  placeholder="Mã phiên sạc"
                  value={energyCashFlowFilterDraft.q}
                  onChange={(event) => {
                    applyEnergyCashFlowFilter({
                      q: event.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-xl-3 col-lg-12 px-2 mb-3">
              <div className="d-flex justify-content-xl-end gap-2">
                <button
                  type="button"
                  className="btn btn-light border-secondary px-4"
                  onClick={resetCashFlowFilter}
                >
                  <i className="fa-regular fa-rotate-left mr-2" />
                  Đặt lại
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row m-0 px-2 pt-3">
          {metrics.map(metricEl)}
        </div>

        <div className="px-4 pb-4">
          <div className="table-responsive rounded" style={{ border: `1px solid ${AppColors.gray[200]}` }}>
            <table className="table align-middle mb-0">
              <thead style={{ background: AppColors.gray[100] }}>
                <tr>
                  <th className="ps-4">Phiên sạc</th>
                  <th>Ngày kết thúc</th>
                  <th className="text-end">Khách trả</th>
                  <th className="text-end">CĐT</th>
                  <th className="text-end">MB</th>
                  <th className="text-end">GT CĐT</th>
                  <th className="text-end">GT MB</th>
                  <th className="text-end">Tiền điện</th>
                  <th className="text-end pe-4">EVG</th>
                </tr>
              </thead>
              <tbody>
                {visibleRows.length ? visibleRows.map((item) => (
                  <tr key={item.transactionId}>
                    <td className="ps-4">
                      <div style={UIHelper.buildFontStyle('700', '13px', AppColors.primary)}>
                        {item.transactionCode}
                      </div>
                      <div style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[600])}>
                        {Utils.formatNumber(item.energyKWh ?? 0)} kWh
                      </div>
                    </td>
                    <td>{Utils.formatDateTimeToString(item.finishedTime, 'DD/MM/YYYY - HH:mm')}</td>
                    <td className="text-end fw-bold">{Utils.formatNumber(item.customerPaid ?? 0)}</td>
                    <td className="text-end">{Utils.formatNumber(item.investor ?? 0)}</td>
                    <td className="text-end">{Utils.formatNumber(item.landlord ?? 0)}</td>
                    <td className="text-end">{Utils.formatNumber(item.investorReferral ?? 0)}</td>
                    <td className="text-end">{Utils.formatNumber(item.premiseReferral ?? 0)}</td>
                    <td className="text-end">{Utils.formatNumber(item.electricityCost ?? 0)}</td>
                    <td className="text-end text-success fw-bold pe-4">{Utils.formatNumber(item.evgOperation ?? 0)}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={9} className="text-center py-6" style={UIHelper.buildFontStyle('500', '14px', AppColors.gray[600])}>
                      Chưa có phiên sạc trong khoảng thời gian này.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {paginationEl}
        </div>
      </div>,
      false,
      false,
      true,
      true
    );
  }, [
    applyEnergyCashFlowFilter,
    defaultEnergyCashFlowFilter,
    energyCashFlow,
    energyCashFlowFilter,
    energyCashFlowFilterDraft,
    filterCashFlowStationEl,
    selectedCashFlowStationDraft,
  ]);

  const rideCashFlowEl = useMemo(() => {
    const settlements = rideDashboardData?.settlements ?? {};
    const tripStats = rideDashboardData?.tripStats ?? {};
    const bookingStats = rideDashboardData?.bookingStats ?? {};
    const recentTrips = rideDashboardData?.recentTrips ?? [];

    const rideMetrics = [
      { label: 'Khách đã trả (Tổng cước)', value: settlements.totalGrossFare, color: AppColors.primary, icon: 'fa-solid fa-wallet', tooltip: 'Tổng tiền cước khách hàng thanh toán cho các chuyến xe ghép' },
      { label: 'EVG thực thu (Phí sàn)', value: settlements.totalEvgRevenue, color: '#16A34A', icon: 'fa-solid fa-sack-dollar', tooltip: 'Doanh thu nền tảng EVG thực nhận sau khi trừ hoa hồng' },
      { label: 'Tài xế nhận (Driver Net)', value: settlements.totalDriverNet, color: '#7C3AED', icon: 'fa-solid fa-id-card', tooltip: 'Tổng thu nhập chi trả thực tế cho tài xế' },
      { label: 'Hoa hồng giới thiệu', value: settlements.totalReferralCommission, color: '#F59E0B', icon: 'fa-solid fa-handshake', tooltip: 'Hoa hồng chi trả cho người giới thiệu tài xế' },
      { label: 'Ưu đãi khuyến mãi', value: settlements.totalPromoDiscount, color: '#EC4899', icon: 'fa-solid fa-tags', tooltip: 'Tổng số tiền voucher/giảm giá đã áp dụng' },
    ];

    const getTripStatusBadge = (status) => {
      switch (status) {
        case 'COMPLETED':
          return <span className="badge badge-light-success fw-bold text-success px-3 py-2">Hoàn thành</span>;
        case 'ACTIVE':
          return <span className="badge badge-light-warning fw-bold text-warning px-3 py-2">Đang chạy</span>;
        case 'SCHEDULED':
          return <span className="badge badge-light-primary fw-bold text-primary px-3 py-2">Sắp chạy</span>;
        case 'CANCELLED':
          return <span className="badge badge-light-danger fw-bold text-danger px-3 py-2">Đã hủy</span>;
        default:
          return <span className="badge badge-light-secondary fw-bold px-3 py-2">{status || 'Chờ chạy'}</span>;
      }
    };

    return UIHelper.buildCard(
      <div>
        <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 px-4 pt-4 pb-2">
          <div>
            <div style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>
              Thống kê vận hành & dòng tiền Xe ghép
            </div>
            <div style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[600])}>
              Tổng {Utils.formatNumber(tripStats.totalTrips ?? 0)} chuyến ({Utils.formatNumber(tripStats.completedTrips ?? 0)} hoàn thành) - {Utils.formatNumber(bookingStats.totalBookings ?? 0)} vé đặt ({Utils.formatNumber(bookingStats.totalSeats ?? 0)} ghế ghép)
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-sm btn-light-primary fw-bold"
              onClick={() => navigate(AppRoute.rideTrips)}
            >
              <i className="fa-solid fa-arrow-up-right-from-square me-1" /> Quản lý chuyến xe
            </button>
            <button
              type="button"
              className="btn btn-sm btn-light-info fw-bold"
              onClick={() => navigate(AppRoute.rideBookings)}
            >
              <i className="fa-solid fa-ticket-simple me-1" /> Quản lý lượt đặt
            </button>
          </div>
        </div>

        {/* Filter */}
        <div className="mx-4 mt-3 mb-2 p-3 rounded" style={{ border: `1px solid ${AppColors.gray[200]}`, background: AppColors.gray[100] }}>
          <div className="row m-0 align-items-end">
            <div className="col-xl-4 col-lg-5 col-md-6 px-2 mb-2">
              <label className="mb-1" style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[600])}>
                Khoảng thời gian
              </label>
              <CustomDateRangePicker
                alignRight={false}
                toggleFontWeight="600"
                toggleElementBorderRadius={8}
                initialValue={rideFilterDraft.selectedValue}
                onPressSave={(selectedValue, startDate, endDate) => {
                  const newFilter = { from: startDate, to: endDate, selectedValue };
                  setRideFilter(newFilter);
                  setRideFilterDraft(newFilter);
                }}
              />
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 px-2 mb-2">
              <button
                type="button"
                className="btn btn-light-secondary w-100 fw-bold"
                onClick={() => {
                  setRideFilter(defaultRideFilter);
                  setRideFilterDraft(defaultRideFilter);
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-1" /> Đặt lại
              </button>
            </div>
          </div>
        </div>

        {/* Metric cards */}
        <div className="px-4 py-3">
          <div className="row m-0">
            {rideMetrics.map((item) => (
              <div className="col-xl col-lg-4 col-md-6 mb-3 px-2" key={item.label}>
                <div
                  className="h-100 p-3 rounded"
                  style={{
                    border: `1px solid ${AppColors.gray[200]}`,
                    background: '#fff',
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded"
                      style={{
                        width: 38,
                        height: 38,
                        color: item.color,
                        background: `${item.color}14`,
                      }}
                    >
                      <i className={item.icon} />
                    </div>
                    <div className="d-flex flex-column">
                      <span style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[600])}>
                        {item.label}
                        {item.tooltip && (
                          <KTTooltip text={item.tooltip}>
                            <i className="fa-regular fa-circle-info ml-1" style={{ color: AppColors.gray[500] }} />
                          </KTTooltip>
                        )}
                      </span>
                      <span style={UIHelper.buildFontStyle('700', '16px', item.color)}>
                        {Utils.formatNumber(item.value ?? 0)} VNĐ
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Recent trips table */}
          <div className="d-flex align-items-center justify-content-between mt-3 mb-2 px-1">
            <span style={UIHelper.buildFontStyle('700', '15px', AppColors.gray[800])}>
              <i className="fa-solid fa-route text-primary me-2" />
              Chuyến xe ghép gần nhất
            </span>
            <span className="text-muted small">
              Hiển thị {recentTrips.length} chuyến mới nhất
            </span>
          </div>

          <div className="table-responsive rounded" style={{ border: `1px solid ${AppColors.gray[200]}` }}>
            <table className="table align-middle mb-0">
              <thead style={{ background: AppColors.gray[100] }}>
                <tr>
                  <th className="ps-4">Mã chuyến</th>
                  <th>Tài xế</th>
                  <th>Tuyến đường</th>
                  <th>Khởi hành</th>
                  <th className="text-center">Ghế ghép</th>
                  <th className="text-end">Giá vé</th>
                  <th className="text-center pe-4">Trạng thái</th>
                </tr>
              </thead>
              <tbody>
                {recentTrips.length ? recentTrips.map((trip) => (
                  <tr key={trip.tripId}>
                    <td className="ps-4">
                      <span style={UIHelper.buildFontStyle('700', '13px', AppColors.primary)}>
                        {trip.tripCode || `#${trip.tripId}`}
                      </span>
                    </td>
                    <td>
                      <div className="fw-bold text-dark">{trip.driver?.fullname || 'Chưa gán'}</div>
                      <div className="text-muted small">{trip.driver?.phone || ''}</div>
                    </td>
                    <td style={{ maxWidth: '280px' }}>
                      <div className="text-truncate text-dark small" title={trip.originAddress}>
                        <i className="fa-solid fa-location-dot text-success me-1" />
                        {trip.originAddress || 'Điểm đi'}
                      </div>
                      <div className="text-truncate text-muted small" title={trip.destinationAddress}>
                        <i className="fa-solid fa-flag-checkered text-danger me-1" />
                        {trip.destinationAddress || 'Điểm đến'}
                      </div>
                    </td>
                    <td>
                      {trip.departureAt ? Utils.formatDateTimeToString(trip.departureAt, 'DD/MM/YYYY - HH:mm') : '—'}
                    </td>
                    <td className="text-center">
                      <span className="badge badge-light-primary fw-bold px-2 py-1">
                        {trip.seatsConfirmed ?? 0} / {trip.seatsOffered ?? 0} ghế
                      </span>
                    </td>
                    <td className="text-end fw-bold">
                      {Utils.formatNumber(trip.driverFixedFarePerSeat || trip.pricePerSeat || 0)} đ
                    </td>
                    <td className="text-center pe-4">
                      {getTripStatusBadge(trip.status)}
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={7} className="text-center py-6" style={UIHelper.buildFontStyle('500', '14px', AppColors.gray[600])}>
                      Chưa có chuyến xe ghép trong khoảng thời gian này.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>,
      false,
      false,
      true,
      true
    );
  }, [
    defaultRideFilter,
    navigate,
    rideDashboardData,
    rideFilterDraft.selectedValue,
  ]);

  return (
    <div className="mt-4" style={{ minHeight: '1200px' }}>
      {/* header */}
      <div className="row m-0 p-0 px-2">
        <div className="col-lg-6 mb-4 px-2">
          {UIHelper.buildCard(
            <div>
              <div
                className="d-flex flex-column p-4"
                style={{
                  borderBottom: `1px solid ${AppColors.gray[200]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                  {user?.fullname}
                </span>
                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                  {user?.role === ChargeConstants.UserRole.AGENCY && !user?.agency?.parentAgencyId
                    ? "Tổng đại lý"
                    : ChargeHelper.Utils.getUserRoleName(user?.role)}
                </span>
              </div>
              <div className="d-flex flex-column gap-3 pt-2 pb-6">
                <div className="px-4 d-flex flex-column gap-3 mt-4">
                  {UIHelper.buildStatisticItem(
                    'rgba(48, 189, 111, 1)',
                    <div className="d-flex align-items-center gap-2">
                      Doanh thu bán hàng trong tháng{' '}
                      <KTTooltip
                        text={`<div><span>Doanh thu bán gói đầu tư HTKD: ${Utils.formatNumber(
                          _.find(
                            revenueSummary?.saleRevenue,
                            (item) => item.orderType === AgencyConstants.SaleOrderType.GROUP
                          )?.totalAmount ?? 0
                        )} VNĐ</span><br /><span>Doanh thu bán nhượng quyền: ${Utils.formatNumber(
                          _.find(
                            revenueSummary?.saleRevenue,
                            (item) => item.orderType === AgencyConstants.SaleOrderType.INVESTOR
                          )?.totalAmount ?? 0
                        )} VNĐ</span><br /><span>Doanh thu bán trụ sạc: ${Utils.formatNumber(
                          _.find(
                            revenueSummary?.saleRevenue,
                            (item) => item.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT
                          )?.totalAmount ?? 0
                        )} VNĐ</span></div>`}
                        textHeader="Doanh thu bán hàng trong tháng"
                        isHtmlContent
                      >
                        <i
                          className="fa-regular fa-info-circle"
                          style={{ color: AppColors.primary }}
                        />
                      </KTTooltip>
                    </div>,
                    `${Utils.formatNumber(
                      _.sumBy(revenueSummary?.saleRevenue, 'totalAmount') ?? 0
                    )} VNĐ`,
                    null,
                    'fa-solid fa-chart-mixed'
                  )}
                  {isAdmin
                    ? UIHelper.buildStatisticItem(
                      'rgba(83, 126, 201, 1)',
                      <div className="d-flex align-items-center gap-2">
                        Doanh thu bán điện trong tháng{' '}
                        <KTTooltip
                          text={`<div><span>Trạm dự án HTKD: ${Utils.formatNumber(
                            _.first(revenueSummary?.groupEnergyRevenue)?.totalAmount ?? 0
                          )} VNĐ</span><br /><span>Trạm nhượng quyền: ${Utils.formatNumber(
                            _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0
                          )} VNĐ</span><br /><span>Trạm nhà điều hành: ${Utils.formatNumber(
                            _.first(revenueSummary?.operatorEnergyRevenue)?.totalAmount ?? 0
                          )} VNĐ</span></div>`}
                          textHeader="Doanh thu bán điện trong tháng"
                          isHtmlContent
                        >
                          <i
                            className="fa-regular fa-info-circle"
                            style={{ color: AppColors.primary }}
                          />
                        </KTTooltip>
                      </div>,
                      `${Utils.formatNumber(
                        _.sum([
                          _.first(revenueSummary?.groupEnergyRevenue)?.totalAmount ?? 0,
                          _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0,
                          _.first(revenueSummary?.operatorEnergyRevenue)?.totalAmount ?? 0
                        ])
                      )} VNĐ`,
                      null,
                      'fa-solid fa-transformer-bolt'
                    )
                    : UIHelper.buildStatisticItem(
                      'rgba(83, 126, 201, 1)',
                      <div className="d-flex align-items-center gap-2">
                        Doanh thu bán điện trong tháng{' '}
                        <KTTooltip
                          text={`<div><span>Trạm dự án HTKD: ${Utils.formatNumber(
                            _.first(revenueSummary?.groupEnergyRevenue)?.totalAmount ?? 0
                          )} VNĐ</span><br /><span>Trạm nhượng quyền: ${Utils.formatNumber(
                            _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0
                          )} VNĐ</span></div>`}
                          textHeader="Doanh thu bán điện trong tháng"
                          isHtmlContent
                        >
                          <i
                            className="fa-regular fa-info-circle"
                            style={{ color: AppColors.primary }}
                          />
                        </KTTooltip>
                      </div>,
                      `${Utils.formatNumber(
                        _.sum([
                          _.first(revenueSummary?.groupEnergyRevenue)?.totalAmount ?? 0,
                          _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0,
                        ])
                      )} VNĐ`,
                      null,
                      'fa-solid fa-transformer-bolt'
                    )}
                  {UIHelper.buildStatisticItem(
                    'rgba(139, 92, 246, 1)',
                    <div className="d-flex align-items-center gap-2">
                      Doanh thu xe ghép trong tháng{' '}
                      <KTTooltip
                        text={`<div><span>Tổng cước khách trả: ${Utils.formatNumber(
                          revenueSummary?.rideRevenue?.totalGrossFare ?? 0
                        )} VNĐ</span><br /><span>Doanh thu EVG thu: ${Utils.formatNumber(
                          revenueSummary?.rideRevenue?.totalEvgRevenue ?? 0
                        )} VNĐ</span><br /><span>Thu nhập tài xế: ${Utils.formatNumber(
                          revenueSummary?.rideRevenue?.totalDriverNet ?? 0
                        )} VNĐ</span><br /><span>Hoa hồng giới thiệu: ${Utils.formatNumber(
                          revenueSummary?.rideRevenue?.totalReferralCommission ?? 0
                        )} VNĐ</span><br /><span>Ưu đãi khuyến mãi: ${Utils.formatNumber(
                          revenueSummary?.rideRevenue?.totalPromoDiscount ?? 0
                        )} VNĐ</span></div>`}
                        textHeader="Doanh thu xe ghép trong tháng"
                        isHtmlContent
                      >
                        <i
                          className="fa-regular fa-info-circle"
                          style={{ color: AppColors.primary }}
                        />
                      </KTTooltip>
                    </div>,
                    `${Utils.formatNumber(
                      revenueSummary?.rideRevenue?.totalGrossFare ?? 0
                    )} VNĐ`,
                    AppResource.icons.icRideRevenue
                  )}
                </div>
              </div>
            </div>,
            false
          )}
        </div>
        {/* thong ke tai khoan */}
        <div className="col-lg-6 mb-4 px-2">
          {UIHelper.buildCard(
            <div>
              {UIHelper.buildCardHeader('Thống kê tài khoản', false, null, false, true)}
              <div className="px-4 pb-4 d-flex align-items-center gap-3">
                <div
                  className=""
                  style={{
                    height: '200px',
                    width: '200px',
                  }}
                >
                  <DoughnutChartJS
                    showTitle={false}
                    showLegend={false}
                    labels={[
                      'Tổng số đại lý bán hàng',
                      'Tổng số NĐT HTKD',
                      'Tổng số NĐT NQ',
                      'Tổng số chủ mặt bằng',
                    ]}
                    datasets={[
                      {
                        data: [
                          agencyStatistic[AgencyConstants.AgencyRole.SALE] ?? 0,
                          agencyStatistic[AgencyConstants.AgencyRole.GROUP] ?? 0,
                          agencyStatistic[AgencyConstants.AgencyRole.INVESTOR] ?? 0,
                          agencyStatistic[AgencyConstants.AgencyRole.LANDLORD] ?? 0,
                        ],
                        borderColor: [
                          'rgba(255, 255, 255, 1)',
                          'rgba(255, 255, 255, 1)',
                          'rgba(255, 255, 255, 1)',
                          'rgba(255, 255, 255, 1)',
                        ],
                        backgroundColor: [
                          'rgba(0, 193, 119, 1)',
                          'rgba(111, 105, 235, 1)',
                          'rgba(248, 174, 46, 1)',
                          'rgba(251, 96, 94, 1)',
                        ],
                        borderWidth: 3,
                      },
                    ]}
                  />
                </div>
                <div className="flex-fill">
                  {UIHelper.buildDoughnutChartLegend([
                    {
                      title: 'Tổng số đại lý bán hàng',
                      color: 'rgba(0, 193, 119, 1)',
                      value: agencyStatistic[AgencyConstants.AgencyRole.SALE] ?? 0,
                    },
                    {
                      title: 'Tổng số NĐT HTKD',
                      color: 'rgba(111, 105, 235, 1)',
                      value: agencyStatistic[AgencyConstants.AgencyRole.GROUP] ?? 0,
                    },
                    {
                      title: 'Tổng số NĐT NQ',
                      color: 'rgba(248, 174, 46, 1)',
                      value: agencyStatistic[AgencyConstants.AgencyRole.INVESTOR] ?? 0,
                    },
                    {
                      title: 'Tổng số chủ mặt bằng',
                      color: 'rgba(251, 96, 94, 1)',
                      value: agencyStatistic[AgencyConstants.AgencyRole.LANDLORD] ?? 0,
                    },
                    {
                      title: 'Tổng số:',
                      value: _.sum(_.values(agencyStatistic)),
                    },
                  ])}
                </div>
              </div>
            </div>,
            false,
            false,
            true,
            true
          )}
        </div>
      </div>

      {/* OLD */}
      {/* <div className="px-4">
        {UIHelper.buildCard(
          <div className="row m-0 p-0">
            <div className="col-lg-4 p-0">
              <div
                className="d-flex flex-column p-4"
                style={{
                  borderBottom: `1px solid ${AppColors.gray[200]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                  {user?.fullname}
                </span>
                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                  {ChargeHelper.Utils.getUserRoleName(user?.role)}
                </span>
              </div>

              <div className="d-flex flex-column gap-3 pt-4 pb-6">
                <div className="px-4 pt-3">
                  <CircleChart
                    title="Trạng thái trụ sạc"
                    total={chargePointStatistic.total}
                    value={chargePointStatistic.charging}
                    color="rgba(44, 143, 241, 1)"
                    valueText="Đang sạc"
                    remainText="Đang nghỉ"
                  />
                </div>

                <div className="px-4 pb-5">
                  <CircleChart
                    title="Trạng thái kết nối trụ sạc"
                    total={chargePointStatistic.total}
                    value={chargePointStatistic.connected}
                    color="rgba(36, 202, 73, 1)"
                    valueText="Đang kết nối"
                    remainText="Mất kết nối"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-8 p-0">
              <CustomCarousel
                images={[
                  { src: AppResource.images.evg.imgSlide1, alt: 'Image 1' },
                  { src: AppResource.images.evg.imgSlide2, alt: 'Image 2' },
                  { src: AppResource.images.evg.imgSlide3, alt: 'Image 3' },
                ]}
                interval={5000}
              />
            </div>
          </div>
        )}
      </div> */}

      {/* thong ke trạm sạc */}
      <div className="">
        <div className="px-4">
          {UIHelper.buildCard(
            <div className="">
              <div className="row m-0 p-0 px-2 pt-4">
                {/* cong suat tuc thi he thong */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(0, 199, 190, 1)',
                    'Công suất tức thì của hệ thống',
                    `${Utils.isValid(systemStatistic?.totalPower)
                      ? Utils.formatNumber((systemStatistic?.totalPower / 1000).toFixed(3))
                      : 0
                    } kW`,
                    AppResource.icons.icTotalPower
                  )}
                </div>
                {/* san luong dien trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(83, 159, 248, 1)',
                    'Tổng sản lượng điện trong ngày',
                    `${Utils.isValid(systemStatistic?.totalEnergy)
                      ? Utils.formatNumber((systemStatistic?.totalEnergy / 1000).toFixed(3))
                      : 0
                    } kWh`,
                    AppResource.icons.icTotalEnergy
                  )}
                </div>
                {/* so phien sac trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(120, 118, 229, 1)',
                    'Tổng số phiên sạc trong ngày',
                    `${Utils.isValid(systemStatistic?.totalTransactions)
                      ? Utils.formatNumber(systemStatistic?.totalTransactions)
                      : 0
                    } phiên`,
                    AppResource.icons.icTotalTransactions
                  )}
                </div>
                {/* tong thoi gian sac trong ngay */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(122, 214, 97, 1)',
                    'Tổng thời gian sạc trong ngày',
                    Utils.isValid(systemStatistic?.totalChargeDuration)
                      ? Utils.convertSecondsToHText(systemStatistic?.totalChargeDuration)
                      : '',
                    AppResource.icons.icTotalDuration
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* thong ke nhanh xe ghep */}
      <div className="mt-4">
        <div className="px-4">
          {UIHelper.buildCard(
            <div className="">
              <div className="row m-0 p-0 px-2 pt-4">
                {/* tong chuyen xe */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(99, 102, 241, 1)',
                    'Tổng chuyến xe ghép',
                    `${Utils.formatNumber(rideDashboardData?.tripStats?.totalTrips ?? 0)} chuyến`,
                    AppResource.icons.icRideTrips
                  )}
                </div>
                {/* tong luot dat xe / booking */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(245, 158, 11, 1)',
                    'Lượt đặt xe (Ghế ghép)',
                    `${Utils.formatNumber(rideDashboardData?.bookingStats?.totalBookings ?? 0)} vé`,
                    AppResource.icons.icRideBookings
                  )}
                </div>
                {/* tai xe xe ghep */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(16, 185, 129, 1)',
                    `Tài xế xe ghép (${Utils.formatNumber(rideDashboardData?.userStats?.approvedDrivers ?? 0)} đã duyệt KYC)`,
                    `${Utils.formatNumber(rideDashboardData?.userStats?.totalDrivers ?? 0)} tài xế`,
                    AppResource.icons.icRideDrivers
                  )}
                </div>
                {/* khach hang di xe ghep */}
                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                  {UIHelper.buildStatisticItem(
                    'rgba(236, 72, 153, 1)',
                    'Khách hàng đi xe ghép',
                    `${Utils.formatNumber(rideDashboardData?.userStats?.totalCustomers ?? 0)} khách hàng`,
                    AppResource.icons.icRideCustomers
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* dong tien phien sac */}
      <div className="mt-4">
        <div className="px-4">
          {energyCashFlowEl}
        </div>
      </div>

      {/* dong tien & van hanh xe ghep */}
      <div className="mt-4">
        <div className="px-4">
          {rideCashFlowEl}
        </div>
      </div>

      {/* bieu do */}
      <div className="mt-4">
        <div className="row m-0 p-0 px-2">
          {/* thong ke dien sac */}
          <div className="col-lg-6 px-2 mb-4">{chartEnergyByDateEl}</div>
          {/* thong ke phien sac */}
          <div className="col-lg-6 px-2 mb-4">{chartTransactionByDateEl}</div>
          {/* thong ke doanh thu ban dien*/}
          <div className="col-lg-6 px-2 mb-4">{chartEnergyRevenueByDateEl}</div>
          {/* thong ke doanh thu ban hang*/}
          <div className="col-lg-6 px-2 mb-4">{chartRevenueByDateEl}</div>
          {/* thong ke khach hang nap tien */}
          <div className="col-lg-6 px-2 mb-4">{chartTopupByDateEl}</div>
          {/* thong ke khach hang */}
          <div className="col-lg-6 px-2 mb-4">{chartNewUsersByDateEl}</div>
          {/* thong ke khach hang moi */}
          {/* <div className="col-lg-6 px-2 mb-4">{chartNewUsersByDateEl}</div> */}
          {/* thong ke trang thai tru sac */}
          <div className="col-lg-6 px-2 mb-4">
            {UIHelper.buildCard(
              <div>
                {UIHelper.buildCardHeader(
                  'Thống kê trạng thái trụ sạc',
                  false,
                  filterChargeStationEl,
                  false,
                  true
                )}
                <div className="px-4 pb-4 d-flex align-items-center gap-3">
                  <div
                    className=""
                    style={{
                      height: '200px',
                      width: '200px',
                    }}
                  >
                    <DoughnutChartJS
                      showTitle={false}
                      showLegend={false}
                      labels={['Sẵn sàng', 'Đang bận', 'Đang bảo trì', 'Trụ lỗi', 'Mất kết nối']}
                      datasets={[
                        {
                          data: [
                            chargePointSummary[ChargeConstants.ChargePointStatus.AVAILABLE] ?? 0,
                            chargePointSummary[ChargeConstants.ChargePointStatus.BUSY] ?? 0,
                            chargePointSummary[ChargeConstants.ChargePointStatus.MAINTAINING] ?? 0,
                            chargePointSummary[ChargeConstants.ChargePointStatus.FAULT] ?? 0,
                            chargePointSummary[ChargeConstants.ChargePointStatus.DISCONNECTED] ?? 0,
                          ],
                          borderColor: [
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                          ],
                          backgroundColor: [
                            'rgba(48, 189, 111, 1)',
                            'rgba(126, 130, 153, 1)',
                            'rgba(255, 157, 28, 1)',
                            'rgba(225, 78, 84, 1)',
                            'rgba(189, 48, 50, 1)',
                          ],
                          borderWidth: 3,
                        },
                      ]}
                    />
                  </div>
                  <div className="flex-fill">
                    {UIHelper.buildDoughnutChartLegend([
                      {
                        title: 'Sẵn sàng',
                        color: 'rgba(48, 189, 111, 1)',
                        value: chargePointSummary[ChargeConstants.ChargePointStatus.AVAILABLE] ?? 0,
                      },
                      {
                        title: 'Đang bận',
                        color: 'rgba(126, 130, 153, 1)',
                        value: chargePointSummary[ChargeConstants.ChargePointStatus.BUSY] ?? 0,
                      },
                      {
                        title: 'Đang bảo trì',
                        color: 'rgba(255, 157, 28, 1)',
                        value:
                          chargePointSummary[ChargeConstants.ChargePointStatus.MAINTAINING] ?? 0,
                      },
                      {
                        title: 'Trụ lỗi',
                        color: 'rgba(225, 78, 84, 1)',
                        value: chargePointSummary[ChargeConstants.ChargePointStatus.FAULT] ?? 0,
                      },
                      {
                        title: 'Mất kết nối',
                        color: 'rgba(189, 48, 50, 1)',
                        value:
                          chargePointSummary[ChargeConstants.ChargePointStatus.DISCONNECTED] ?? 0,
                      },
                      {
                        title: 'Tổng số:',
                        value: _.sum(_.values(chargePointSummary)),
                      },
                    ])}
                  </div>
                </div>
                <div className='p-4'>
                  {UIHelper.buildNegativeButton(
                    'Danh sách trụ sạc',
                    () => {
                      Utils.openInNewTab(AppRoute.pointList);
                    }
                  )}
                </div>
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
          {/* thong bao */}
          <div className="col-lg-6 px-2 mb-4">
            {UIHelper.buildCard(
              <div>
                <div className='d-flex justify-content-between'>
                  {UIHelper.buildCardHeader(
                    'Thông báo vận hành',
                    false,
                    null,
                    false,
                    true,
                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                      Tổng:{' '}
                      <span style={{ color: AppColors.primary }}>
                        {Utils.formatNumber(totalSystemLog)} thông báo
                      </span>
                    </span>
                  )}
                  <div className='px-4 py-3'>
                    <DropdownFilterTable
                      id="systemLog"
                      isLightButton={true}
                      toggleElementBorderRadius={10}
                      filterComponent={[
                        <div className="col-12 pb-2 p-0">
                          {UIHelper.buildFormLabel('Trạm sạc')}
                          {filterChargeStationSystemLogEl}
                        </div>,
                        <div className="col-12 p-0">
                          <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                            Khoảng thời gian thống kê
                          </label>
                          <CustomDateRangePicker
                            alignRight={true}
                            toggleFontWeight="600"
                            toggleElementBorderRadius={5}
                            initialValue={filterSystemLogDropdown.selectedValue}
                            onPressSave={(selectedValue, startDate, endDate) => {
                              setFilterSystemLogDropdown({
                                ...filterSystemLogDropdown,
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                              });
                            }}
                            direction='dropup'
                          />
                        </div>
                      ]}
                      resetDefaultTable={() => {
                        const updateSystemLogFilter = {
                          ...filterSystemLog,
                          from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                          to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                          selectedValue: dateFilter.baMuoiNgayGanNhat,
                          stationId: '',
                        };
                        setSelectedChargeStationSystemLog(null);
                        setFilterSystemLogDropdown(updateSystemLogFilter);
                        setFilterSystemLog(updateSystemLogFilter);
                      }}
                      saveFilter={() => {
                        setFilterSystemLog(filterSystemLogDropdown);
                      }}
                      isDefaultFilter={Utils.checkDefaultFilter(
                        ['selectedValue', 'from', 'to', 'page', 'limit'],
                        filterSystemLog,
                        dateFilter.baMuoiNgayGanNhat,
                      )}
                    />
                  </div>
                </div>
                {systemLogList?.length
                  ? (
                    <div className="px-4 mb-4">
                      <CustomCardMore
                        scrollTargetSelector=".system-log-scroll"
                        filter={filterSystemLog}
                        setFilter={setFilterSystemLog}
                        dataList={systemLogList}
                        dataTotal={totalSystemLog}
                        hasMore={systemLogList?.length < totalSystemLog}
                      >
                        <div
                          className="system-log-scroll"
                          style={{
                            maxHeight: '260px',
                            overflowY: 'auto',
                          }}
                        >
                          {systemLogList?.map((item, index) => {
                            return (
                              <div key={item?.messageId ?? index}>
                                {UIHelper.buildCellSystemInfo(
                                  <i
                                    className={`${ChargeHelper.Utils.getMessageLogTypeIcon(
                                      item?.level
                                    )} text-${ChargeHelper.Utils.getMessageLogTypeColor(item?.level)}`}
                                    style={{
                                      fontSize: '22px',
                                    }}
                                  />,
                                  item?.title,
                                  Utils.formatDateTimeToString(item?.createdAt, 'DD/MM/YYYY - HH:mm'),
                                  true,
                                  () => {
                                    Utils.openInNewTab(`${AppRoute.pointList}/${item?.pointId}`)
                                  }
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </CustomCardMore>
                    </div>
                  ) : (
                    <EmptyView
                      icon={imgEmptyNoData}
                      title="Không có dữ liệu để hiển thị"
                      text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                    />
                  )}
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHomeView;
